<template>
  <div class="mfa-qrcode-scan">
    <h1>Ativação de MFA</h1>

    <div v-if="qrCodeBase64">
      <p>Escaneie o QR Code abaixo com seu aplicativo de autenticação:</p>
      <div class="qrcode-container">
        <img :src="'data:image/png;base64,' + qrCodeBase64" alt="QR Code" />
      </div>
    </div>

    <div v-if="secretKey">
      <p>Ou insira manualmente a chave secreta no aplicativo:</p>

      <div>
        <b-input-group label="" label-for="code">
          <b-form-input v-model="secretKey" type="text" disabled></b-form-input>
          <b-input-group-append>
            <b-button @click="copyCode()" v-b-tooltip.click="'Copiado!'">
              <b-icon
                v-if="copiedMessage"
                icon="check-all"
                aria-hidden="true"
              ></b-icon>
              <b-icon v-else icon="files" aria-hidden="true"></b-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <!-- <button @click="onConfirm">Informar código MFA</button> -->
    
    </div>
    <!-- <button @click="activateMfa">Ativar MFA</button> -->
  </div>
</template>

<script>
export default {
  name: "MfaEnable",
  props: {
    secretKey: String,
    qrCodeBase64: String,
  },
  data() {
    return {
      // qrCodeBase64: null,
      // secretKey: null,
      copiedMessage: false,
    };
  },
  methods: {
    // async activateMfa() {
    //   try {
    //     const response = await this.$apiScheduler.get(
    //       `/mfa/enable/${this.$store.getters.userId}`
    //     );
    //     // const response = await fetch("http://localhost:5004/mfa/enable/9163");
    //     const data = response.data;
    //     this.qrCodeBase64 = data.qrCodeBase64;
    //     this.secretKey = data.secretKey;
    //   } catch (error) {
    //     console.error("Erro ao ativar MFA:", error);
    //   }
    // },
    copyCode() {
      if (this.copiedMessage) {
        this.copiedMessage = false;
      } else {
        navigator.clipboard
          .writeText(this.secretKey)
          .then(() => {
            this.copiedMessage = true;
          })
          .catch((err) => {
            console.error("Erro ao copiar: ", err);
          });
      }
    },
    showCopiedMessage() {
      this.copiedMessage = true;
    },
    onConfirm() {
      this.$emit("mfaConfirmed");
    },
  },
};
</script>

<style scoped>
.mfa-qrcode-scan {
  text-align: center;
  padding: 20px;
}

.qrcode-container img {
  max-width: 200px;
  margin: 20px 0;
}

.secret-key {
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0;
  word-break: break-word;
}

/* button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
} */
</style>